module.exports = __webpack_public_path__ + "static/reece-9f16d18adf1feb042adf7faca16d2bbc.jpg";